import { BeatblipUtils } from 'src/app/consts/beatblip-utils';
import { ToastrService } from 'ngx-toastr';
import { ReportService } from 'src/app/_services/report.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ChartColor, ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Label } from 'ng2-charts';
import { beatBlipSubscriptionConsts } from 'src/app/consts/beatBlipSubscriptionConsts';
import { ProjectService } from 'src/app/_services/project.service';

@Component({
  selector: 'app-tag-testcase-report',
  templateUrl: './tag-testcase-report.component.html',
  styleUrls: ['./tag-testcase-report.component.scss']
})
export class TagTestcaseReportComponent implements OnInit {


  @ViewChild('failReasonData') failReasonData: ElementRef;

  projectId: any;
  reportId: any;
  failShow: boolean;

  reportSummaryData: any=[];
  failReasonList: any=[];
  auditInfoData: any=[];
  caseDataAudit = new Array();

  
  pagesSize = beatBlipSubscriptionConsts.pagesSize;
  perpageitem = beatBlipSubscriptionConsts.perpageitem;
  selectedPage: any;


  public chartOptionSelect = ['pie','bar'];
  copyMessage: any;
  public barChartColors: ChartColor[] = [
    'rgb(92, 184, 92)',
    'rgb(217, 83, 79)',
    'rgb(236, 59, 15)',
    'rgb(240, 173, 78)',
     'rgb(91, 192, 222)', 
     'rgb(102, 205, 170)'
  ]
  public barChartOptions: ChartOptions = {
    responsive: true,
    legend: {
      display: true,
      position: 'bottom',
    }
  };
  charData: any=[];
  public barChartLabels: Label[];
  public barChartType: ChartType = 'bar';
  public barChartLegend = true;
  public barChartPlugins = [];
  public barChartData: ChartDataSets[]=[];
  public pieColor: ChartColor[]=[];
  chartList: Array<Object> = [];
  blinkArry: any[]=[];
  numarray: Array<Number>=[];
  headerOptions = {
    showSetting : false,
    showSearch: false,
    heading : 'Tag Case Summary',
    data: undefined,
  }

  constructor(private activateRoute: ActivatedRoute,
    private report: ReportService,
    private toaster: ToastrService,
    private router: Router,
    private projectService : ProjectService,
    private util: BeatblipUtils) { }

  ngOnInit() {
    this.activateRoute.paramMap.subscribe((params) => {
      this.projectId = params.get('pid');
      this.reportId = params.get('reportid');
    })
    this.projectService.getProjectById(this.projectId).subscribe((
      data => {
        this.headerOptions.data = { 
          projectId : this.projectId,
          projectName: data['projectName']
        };
      }
    ))
    this.getTestCaseReport(this.projectId,this.reportId);
  }


  getTestCaseReport(projectId,reportId){
      this.report.tagTestCaseReport(projectId,reportId)
      .subscribe((data) => {
        this.reportSummaryData = data['testExecutionStats'];
        //console.log('reportSummaryData', this.reportSummaryData);

        let dataArr = [];
        for(let s=0; s< this.reportSummaryData.length;s++){
          if(this.reportSummaryData[s].status==="PASS"){
            dataArr['pass']=[s+1];
          }if(this.reportSummaryData[s].status==="INCONCLUSIVE"){
            dataArr['inconclusive']=[s+1];
          }if(this.reportSummaryData[s].status==="FAIL"){
            dataArr['fail']=[s+1];
          }if(this.reportSummaryData[s].status==="BLOCKED"){
            dataArr['blocked']=[s+1];
          }if(this.reportSummaryData[s].status==="NOTRUN"){
            dataArr['notRun']=[s+1];
          }if(this.reportSummaryData[s].status==="SKIPPED"){
            dataArr['skipped']=[s+1];
          }
            }
            let chartObj = new Object();
          chartObj['pass'] = dataArr['pass']?dataArr['pass']:0;
          chartObj['fail'] = dataArr['fail']?dataArr['fail']:0;
          chartObj['blocked'] = dataArr['blocked']?dataArr['blocked']:0;
          chartObj['inconclusive'] = dataArr['inconclusive']?dataArr['inconclusive']:0
          chartObj['notRun'] = dataArr['notRun']?dataArr['notRun']:0;
          chartObj['skipped'] = dataArr['skipped']?dataArr['skipped']:0;
          this.chartList.push(chartObj);
    
          //console.log('dataArr',dataArr);
          
          this.barChartLabels = ['Pass','Fail','Blocked','Inconclusive','Not Run','Skipped']
          for(let c of this.chartList){
            this.blinkArry.push(Object.values(c));
          }
          this.numarray = JSON.parse(JSON.stringify(this.blinkArry[0]));
          const toNumbers = arr => arr.map(Number);
          var n = toNumbers(this.numarray);
          this.barChartData = [{ data:n,label: 'Bar Chart' ,backgroundColor: this.barChartColors,hoverBackgroundColor: this.barChartColors,hoverBorderColor: this.barChartColors}];
          })
  }

  openTagStepReport(projectId, reportId, testDataId, dataIterationIndex, path) {
      //console.log('projectid',projectId,'reportId',reportId,'testDataId',testDataId,'dataIterationIndex',dataIterationIndex,'path',path);
      this.router.navigate(['tagTestStepReport/'+projectId+'/'+reportId+'/'+testDataId+'/'+dataIterationIndex+'/'+path]);
  };

  failureReason(value:boolean){
    this.auditInfoData = []
    this.failShow = value;
    if(this.failShow){
      let i = 0;
      for(let f of this.reportSummaryData){
        //console.log(this.reportSummaryData);
        
        i++;
        this.report.getTestProjectReport(this.projectId,this.reportId,f.testDataId,f.dataIterationIndex,f.path).subscribe((data) => {
          //console.log('data fail',data);
          var arrayData = new Array();
          var object = new Object();
          object['key'] = f.testDataId;
          var testStepReport = data.testStepReport;
          if (testStepReport) {
            for (var i = 0; i < testStepReport.length; i++) {
                var step = testStepReport[i];
                if (step.resultState.status !== 'PASS' && step.resultState.status !== 'NOTRUN' && step.resultState.status !== 'SKIPPED') {
                    arrayData.push('Step: ' + (i + 1) + ' become ' + step.resultState.status);
                    if (step.auditInfoS) {
                        for (var j = 0; j < step.auditInfoS.length; j++) {
                            var tempData = step.auditInfoS[j];
                            if (tempData.includes('Error')) {
                                arrayData.push(tempData);

                            }
                        }
                    }

                }

            }
            //console.log('arrayData',arrayData);
            
            object['value'] = arrayData;

            this.auditInfoData.push(object);
            //console.log('auditInfoData',this.auditInfoData);

            
        }
        })
        }


    }

  }

  tagReport(){
    this.router.navigate(['/report/projectTagReport/' + this.projectId]);
  }


  copyToClipboard(item,id): void {
    //console.log(item,id)
    var copyItem;
    for (let entry of item) {
      if(entry.key===id){
        //console.log('Map key is:',entry.value);
        copyItem = entry.value;
      }
     
    }
    this.util.copyToClipboard(copyItem);
  this.toaster.clear();
  this.toaster.success('Copy To Clipboard');
  }

  
onPageChange(newValue) {
  this.selectedPage = newValue;
  this.perpageitem = newValue;
}
}